import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import getDecryptData from '../../../helper/getDecryptData';
import axiosInstance from '../../../axiosInstance';

const AccountOffer = () => {

  const decryptdatajson = getDecryptData();

  const { dataAuth } = useBlogContext();

  const [Loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [Notification, setNotification] = useState([]);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  const [sortOrder, setSortOrder] = useState(1); // 1 for Newest, 2 for Oldest
  const [filterRange, setFilterRange] = useState("all"); // 'all', 'today', '7days', '1month'

  const handleSortChange = (event) => {
    setSortOrder(parseInt(event.target.value));
  };

  const handleFilterChange = (event) => {
    setFilterRange(event.target.value);
  };

  const [formData, setFormData] = useState({
    userId: null,
    type: 0,
    note: `Add Funds By ${decryptdatajson.username} `,
    amount: 0,
    wallet: 0,
    trans: 0,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  //form handle

  const fetchnotificationById = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson._id;

    try {
      setLoading(true);

      const { data } = await axiosInstance.get(`/all-notification?userId=${id}&type=2`);
      const { success } = data;

      if (success) {
        setNotification(data.notifications);
      }
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
      setNotification([]);

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchnotificationById();
    dataAuth();
  }, []);

  useEffect(() => {
    if (formData.trans) {
      setNotification(Notification.reverse());
      console.log("formData.trans", formData.trans);
    }
  }, [formData.trans]);

  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
    toast.success(`${code} copied!`);
  };



  return (
    <>

      <HeaderPage title={'My Offer'} />



      <main className="page-content bg-white mypadding overflow-auto pb-4 px-0" >


        <div className="container pb-0 overflow-hidden">

          <div className="px-3">
            <div className="row g-4">
              {!Loading ? (
                Notification.length > 0 ? (
                  Notification.map((offer) => (
                    <div
                      key={offer._id}
                      className="d-flex"
                      style={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        marginBottom: "15px",
                      }}
                    >
                      {/* Left discount strip */}
                      <div
                        style={{
                          backgroundColor:
                            offer.off === "20%"
                              ? "rgb(108, 117, 125)"
                              : offer.off === "50%"
                                ? "rgb(52, 58, 64)"
                                : "rgb(220, 53, 69)",
                          color: "#fff",
                          width: "60px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          writingMode: "vertical-rl",
                          textOrientation: "mixed",
                          fontWeight: "bold",
                          fontSize: "13px",
                          letterSpacing: "1px",
                        }}
                      >
                        {offer.off ? offer.off + " OFF" : "OFFER"}
                      </div>

                      {/* Offer details */}
                      <div className="flex-grow-1 p-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="fw-bold mb-0">{offer.code || "SPECIAL"}</h6>
                          <button
                            className="btn btn-link fw-bold text-danger p-0"
                            style={{ textDecoration: "none" }}
                            onClick={() => copyToClipboard(offer.code)}
                          >
                            APPLY
                          </button>
                        </div>

                        {/* Optional: Different lines for different types */}
                        {offer.type === 2 && offer.off ? (
                          <p className="text-success small fw-bold mb-1">
                            Save {offer.off} on this order
                          </p>
                        ) : (
                          <p className="text-muted small mb-1">
                            {new Date(offer.createdAt).toLocaleDateString("en-US", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })}
                          </p>
                        )}

                        <p className="small mb-0">{offer.note}</p>
                        {/* <button
                          className="btn btn-link text-decoration-none p-0 mt-1 small text-primary"
                          style={{ fontWeight: 500 }}
                        >
                          + MORE
                        </button> */}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted">No offers available</p>
                )
              ) : (
                <>
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="skeleton mb-4"
                      style={{ height: 80, width: "100%", borderRadius: "12px" }}
                    />
                  ))}
                </>
              )}
            </div>
          </div>


        </div>



        <NavBar />

      </main>
    </>
  )
}

export default AccountOffer